// ===========================================
// Meet & Greet "booking submitted" message (#412)
// ===========================================
//
// What the family is told after a public booking. When the server's spam check
// could not run it sends NO verification email (`verificationEmailSent: false`,
// plan md/plan/412.md D20), so "check your email" would send them looking for
// nothing. `true` means the email was attempted, the same copy as before #412.

import { Typography } from '@mui/material';

interface BookingSubmittedMessageProps {
  verificationEmailSent: boolean;
  email: string;
}

export default function BookingSubmittedMessage({ verificationEmailSent, email }: BookingSubmittedMessageProps) {
  if (!verificationEmailSent) {
    return (
      <>
        <Typography variant="h6" sx={{ mb: 2 }}>
          We&apos;ve received your booking.
        </Typography>
        <Typography color="text.secondary" sx={{ mb: 4 }} data-testid="booking-no-email">
          The school will be in touch to confirm your meet &amp; greet.
        </Typography>
      </>
    );
  }
  return (
    <>
      <Typography variant="h6" sx={{ mb: 2 }}>
        Please check your email to verify your booking.
      </Typography>
      <Typography color="text.secondary" sx={{ mb: 4 }}>
        We&apos;ve sent a verification link to <strong>{email}</strong>.
        Click the link in the email to confirm your meet &amp; greet booking.
      </Typography>
    </>
  );
}
